import React from 'react';
import ReactDOM from 'react-dom';

import App from './choose-journey/App';

if ( document.getElementById('choose-journey') ) {
  ReactDOM.render(
    <App />,
    document.getElementById('choose-journey')
  );
}
